import React from 'react';
import VerificationForm from 'components/user/two_factor/verification_form';
import { useMutation } from '@apollo/client/react';
import { useIntl } from 'react-intl';
import { setAuthenticated } from 'utils/authentication';
import ConfirmMutation from 'mutations/user/two_factor/verification';

const TwoFactorVerification = () => {
  const intl = useIntl();
  const [confirmMutation, { loading }] = useMutation(ConfirmMutation, {
    onCompleted: ({ userLoginTwoFactor }) => {
      setAuthenticated(userLoginTwoFactor.expiresIn);
    },
  });

  return (
    <VerificationForm
      initialValues={{
        code: '',
      }}
      onSubmit={(values, { setFieldError }) => {
        confirmMutation({ variables: { code: values.code.toString() } }).catch(() => {
          setFieldError('code', intl.formatMessage({ id: 'error.user.two_factor' }));
        });
      }}
      processing={loading}
    />
  );
};

export default TwoFactorVerification;
